import { NgModule, forwardRef }      from '@angular/core';
import { DynamicTypeBuilder }     from './type.builder';
import { DynamicTemplateBuilder } from './template.builder';
import DataProtection from '../dataprotection.component';
import { DpsVcdModule } from '../dataprotection-vcd/dataprotection-vcd.module';
import { DpsVcModule } from '../dataprotection-vc/dataprotection-vc.module';

@NgModule({
    imports:      [ DpsVcModule, DpsVcdModule ],
    declarations: [ DataProtection ],
    exports:      [ DataProtection ]
})

export class DynamicDPSModule {

    static forRoot() {
        return {
            ngModule: forwardRef(() => DynamicDPSModule),
            providers: [
                DynamicTemplateBuilder,
                DynamicTypeBuilder
            ]
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dynamic-dps/dynamic-dps.module.ts